module.exports = __webpack_public_path__ + "img/L_323_328.b8f762ff.png";